"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Skeleton2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Skeleton"));
var _jsxRuntime = require("react/jsx-runtime");
var _Skeleton;
const NavbarLoader = () => _Skeleton || (_Skeleton = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton2.default, {
  viewBox: "0 0 80 64",
  height: 64,
  width: 80,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
    x: "5",
    y: "20",
    rx: "6",
    ry: "6",
    width: "70",
    height: "25"
  })
}));
var _default = exports.default = NavbarLoader;